import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPageRightArrow = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 52,
	height: 52,
	viewBox: "0 0 52 52",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: .5,
		y: .5,
		width: 51,
		height: 51,
		stroke: "#909090"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M21.0275 13L17.9725 16.055L27.8958 26L17.9725 35.945L21.0275 39L34.0275 26L21.0275 13Z",
		fill: "#90919C"
	})]
});
export default SvgPageRightArrow;
